import { createStore, combineReducers, applyMiddleware } from 'redux';

import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { apiMiddleware } from 'redux-api-middleware';
import samaReducer from 'sama_global/modules/olimpic';
import userReducer from '@/modules/User';
import newsReducer from '@/modules/News';
import socketReducer from '@/modules/Socket';
import requestsReducer from '@/modules/Requests';
import simulatorsrReducer from '@/modules/Simulators';
import homeworksrReducer from '@/modules/Homework';
import mainhomeworkReducer from '@/modules/Mainhomeworks';
import certificationReducer from '@/modules/Certification';
import arifmetikBookReducer from '@/modules/ArifmetikBook';
import notifierReducer from '@/modules/Notifier';
import examsReducer from '@/modules/Exams';
import olimpicReducer from '@/modules/Olimpic';
import deviceReducer from '@/modules/Device';
import winnersReducer from '@/modules/PastWinners';
import starRatingReducer from '@/modules/StarRating';

import WebSocket from '@/utils/middleware/WebSocket';
import ApiAuthInjector from '@/utils/middleware/AuthApiInjector';
import Requests from '@/utils/middleware/Requests';
import Forms from '@/utils/middleware/Forms';

const middleware = [
  ApiAuthInjector,
  apiMiddleware,
  WebSocket,
  Requests,
  Forms,
  thunk,
];

if (process.env.MODE !== 'production') {
  middleware.push(createLogger({ collapsed: true }));
}

const rootReducer = combineReducers({
  form: formReducer,
  user: userReducer,
  news: newsReducer,
  socket: socketReducer,
  requests: requestsReducer,
  homeworks: homeworksrReducer,
  mainhomeworks: mainhomeworkReducer,
  simulators: simulatorsrReducer,
  exams: examsReducer,
  notifier: notifierReducer,
  arifmetikBook: arifmetikBookReducer,
  certification: certificationReducer,
  olimpic: olimpicReducer,
  sama: samaReducer,
  device: deviceReducer,
  winners: winnersReducer,
  starRating: starRatingReducer,
});

const store = createStore(rootReducer, applyMiddleware(...middleware));

export default store;
